// extracted by mini-css-extract-plugin
export default {"buttons__row":"MarkenDownloadBtn_buttons__row__CqkIf","buttons__downloadImg":"MarkenDownloadBtn_buttons__downloadImg__yjCvj"};